import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CollabObject" */ './lazyIndex')
);

export { CollabObjectsDocument } from './graphql/__generated__/CollabObjectsQuery.interface';
export const lazyGetCollabObjectGraphQL = new LazyAction(lazyModule, m => m.getCollabObjectGraphQL);
export const lazyCreateCollabObjectService = new LazyAction(
    lazyModule,
    m => m.createCollabObjectService
);
export const lazyUpdateCollabObjectService = new LazyAction(
    lazyModule,
    m => m.updateCollabObjectService
);
export const lazyReserveCollabObjectResourceService = new LazyAction(
    lazyModule,
    m => m.reserveCollabObjectResourceService
);
export const lazyCommitCollabObjectResourceService = new LazyAction(
    lazyModule,
    m => m.commitCollabObjectResourceService
);

export {
    CreateCollabObjectRequest,
    UpdateCollabObjectRequest,
    Participant,
    CollabObjectResource,
    CommitCollabObjectResourceRequest,
} from './rest/interfaces';

//Non lazy utils
export { initCollabObjectPerfDatapoint } from './utils/initCollabObjectPerfDatapoint';
